// 🧿 طلسم محافظ فایل
import React from "react";
// Common Components
import { TabBox } from "src/Components";
// Local Component
import UnderlyingAsset from "./UnderlyingAsset";
import Futures from "./Futures";
import Options from "./Options";
import CommodityPairPosition from "./CommodityPairPosition";

enum ActiveTab {
  CommodityPairPosition = 0, //جفت پوزیشن کالا
  Options = 1, // اختیار
  Futures = 2, // آتی
  UnderlyingAsset = 3, // دارایی پایه
}

const tabsChildren = [
  { index: ActiveTab.UnderlyingAsset, title: "دارایی پایه" },
  { index: ActiveTab.Futures, title: "آتی" },
  { index: ActiveTab.Options, title: "اختیار" },
  { index: ActiveTab.CommodityPairPosition, title: "جفت پوزیشن کالا" },
];

const IMEMarketWatch = () => {
  // local state
  const [activeTab, setActiveTab] = React.useState<number>(
    ActiveTab.CommodityPairPosition
  );

  const Tabs = React.useMemo(() => {
    switch (activeTab) {
      case ActiveTab.CommodityPairPosition:
        return <CommodityPairPosition />;
      case ActiveTab.Options:
        return <Options />;
      case ActiveTab.Futures:
        return <Futures />;
      case ActiveTab.UnderlyingAsset:
        return <UnderlyingAsset />;
      default:
        return <></>;
    }
  }, [activeTab]);

  return (
    <div className="flex flex-col justify-start items-start gap-2 relative min-h-screen pt-5 mx-auto p-8 w-full h-full">
      <div className="w-min">
        <TabBox
          activeTab={activeTab}
          children={tabsChildren}
          onChange={(_, i) => setActiveTab(i)}
        />
      </div>
      {Tabs}
    </div>
  );
};

export default IMEMarketWatch;
